// @flow
export const TRANSLATOR_TEXT_TRANSLATION_FETCH = 'TRANSLATOR_TEXT_TRANSLATION_FETCH'
export const TRANSLATOR_TEXT_TRANSLATION_SUCCESS = 'TRANSLATOR_TEXT_TRANSLATION_SUCCESS'
export const TRANSLATOR_TEXT_TRANSLATION_FAIL = 'TRANSLATOR_TEXT_TRANSLATION_FAIL'
